import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AssignmentRuleCandidateRepositoryService extends BaseRepositoryService<
  ModelRegistry['assignment-rule-candidate']
> {
  recordName = 'assignment-rule-candidate';
  implementMethods = ['query'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/assignment-rule-candidate': AssignmentRuleCandidateRepositoryService;
  }
}
